var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47754 16.5266C7.45958 18.4996 4.21495 18.4918 2.20824 16.4991C0.202098 14.5075 0.194193 11.2849 2.18124 9.28097L2.17957 9.27981L9.4787 2.03191L10.3915 1.12583C11.9033 -0.375275 14.3538 -0.375275 15.8656 1.12583C17.3773 2.62693 17.3773 5.06052 15.8656 6.5622L7.81956 14.4688L7.81673 14.4665C6.82517 15.4158 5.24476 15.4091 4.26502 14.4412C3.28528 13.4727 3.27911 11.9114 4.2397 10.9328L4.23687 10.9294L5.1328 10.0453L9.61251 5.62071L10.5079 6.50597L5.1328 11.8146C4.63785 12.3028 4.63785 13.0953 5.1328 13.584C5.62774 14.0727 6.43029 14.0727 6.92466 13.584L14.9532 5.65496L14.9509 5.65329L14.9813 5.62739C15.9892 4.62683 15.9892 3.00368 14.9813 2.00318C13.9735 1.00268 12.3402 1.00262 11.3323 2.00318L11.3053 2.03358L11.3037 2.03242L10.3914 2.93793L3.09183 10.1859C1.58006 11.687 1.58006 14.1206 3.09183 15.6217C4.60359 17.1228 7.05468 17.1228 8.56529 15.6217L14.9522 9.27981L15.8644 8.37431L16.7767 9.27981L15.8644 10.1859L9.4787 16.5278L9.47754 16.5266Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInput);
export default __webpack_public_path__ + "static/media/file-input.ce720e3b0359c293863fde06a15f8810.svg";
export { ForwardRef as ReactComponent };